module.exports = __webpack_public_path__ + "img/personalpac-logo.9fa4188c.svg";